import { Component, OnInit } from '@angular/core';

import { SpinnerService } from '@app/shared/spinner';

@Component({
  standalone: false,
  selector: 'view-config-lacks',
  templateUrl: './config-lacks.component.html',
  styleUrls: ['./config-lacks.component.scss']
})
export class ConfigLacksComponent implements OnInit {
  constructor(private spinnerSvc: SpinnerService) {}

  ngOnInit() {
    this.spinnerSvc.hide();
  }
}
